import styled from 'styled-components';

export const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const PlaceholderText = styled.div`
  padding: 5px 5px 5px 15px;
  font-size: 14px;
`;

export const InputWrapper = styled.div`
  width: 525px;
`;
